__turbopack_context__.v({
  "plp-btn-txt": "_34bv4q_plp-btn-txt",
  "sort": "_34bv4q_sort",
  "sort-item": "_34bv4q_sort-item",
  "sort-item-anchor": "_34bv4q_sort-item-anchor",
  "sort-label": "_34bv4q_sort-label",
  "sort-options": "_34bv4q_sort-options",
});
